import React from "react"
import { Quill } from "react-quill"

// Custom Undo button icon component for Quill editor. You can import it directly
// from 'quill/assets/icons/undo.svg' but I found that a number of loaders do not
// handle them correctly
const CustomUndo = () => (
  <svg viewBox="0 0 18 18">
    <polygon className="ql-fill ql-stroke" points="6 10 4 12 2 10 6 10" />
    <path
      className="ql-stroke"
      d="M8.09,13.91A4.6,4.6,0,0,0,9,14,5,5,0,1,0,4,9"
    />
  </svg>
)

// Redo button icon component for Quill editor
const CustomRedo = () => (
  <svg viewBox="0 0 18 18">
    <polygon className="ql-fill ql-stroke" points="12 10 14 12 16 10 12 10" />
    <path
      className="ql-stroke"
      d="M9.91,13.91A4.6,4.6,0,0,1,9,14a5,5,0,1,1,5-5"
    />
  </svg>
)

// Undo and redo functions for Custom Toolbar
function undoChange() {
  this.quill.history.undo()
}
function redoChange() {
  this.quill.history.redo()
}

// Add sizes to whitelist and register them
const Size = Quill.import("formats/size")
Size.whitelist = ["small", "medium", "large", "huge"]
Quill.register(Size, true)

// Add fonts to whitelist and register them
var Font = Quill.import("formats/font")
Font.whitelist = [
  "Arial",
  "Helvetica",
  "Serif",
  "Courier",
  "monospace",
  "Robot",
  "Verdana",
]

Quill.register(Font, true)

// Modules object for setting up the Quill editor
export const modules = {
  toolbar: {
    container: "#toolbar",
    handlers: {
      undo: undoChange,
      redo: redoChange,
    },
  },
  history: {
    delay: 500,
    maxStack: 100,
    userOnly: true,
  },
}

// Formats objects for setting up the Quill editor
export const formats = [
  "header",
  "font",
  "size",
  "bold",
  "italic",
  "underline",
  "align",
  "strike",
  "script",
  "blockquote",
  "background",
  "list",
  "bullet",
  "indent",
  "link",
  "image",
  "color",
  "code-block",
]

// Quill Toolbar component
export const QuillToolbar = ({ image }) => {
  return (
    <div id="toolbar">
      {/* <span className="ql-formats">
      <select className="ql-font" defaultValue="Arial">
        <option value="Arial">Arial</option>
        <option value="Helvetica">Helvetica</option>
        <option value="Serif">Serif</option>
        <option value="Courier">Courier</option>
        <option value="monospace">monospace</option>
        <option value="Robot">Robot</option>
        <option value="Verdana">Verdana</option>
      </select>
    </span> */}

      <span className="ql-formats">
        <select className="ql-size" defaultValue={"medium"}>
          <option value="small">Small</option>
          <option value="medium">Normal</option>
          <option value="large">Large</option>
          <option value="huge">Huge</option>
        </select>
        {/* <select className="ql-header">
        <option value="1">Heading</option>
        <option value="2">Sub-Heading</option>
        <option value="0">Normal</option>
      </select> */}
      </span>
      <span className="ql-formats">
        <button className="ql-bold" />
        <button className="ql-italic" />
        <button className="ql-underline" />
        <button className="ql-strike" />
      </span>
      {!image && (
        <span className="ql-formats">
          <button className="ql-list" value="ordered" />
          <button className="ql-list" value="bullet" />
          {/* <button className="ql-indent" value="-1" /> */}
          {/* <button className="ql-indent" value="+1" /> */}
        </span>
      )}
      {!image && (
        <span className="ql-formats">
          <button className="ql-script" value="super" />
          <button className="ql-script" value="sub" />
          <button className="ql-blockquote" />
        </span>
      )}
      {!image && (
        <span className="ql-formats">
          <select className="ql-align" />
          <select className="ql-color" />
          <select className="ql-background" />
        </span>
      )}
      <span className="ql-formats">
        {!image && <button className="ql-link" />}
        {!image && <button className="ql-image" />}
        {/* <button className="ql-video" /> */}
      </span>
      {!image && (
        <span className="ql-formats">
          {/* <button className="ql-formula" /> */}
          <button className="ql-code-block" />
          <button className="ql-clean" />
        </span>
      )}
      <span className="ql-formats">
        <button className="ql-undo">
          <CustomUndo />
        </button>
        <button className="ql-redo">
          <CustomRedo />
        </button>
      </span>
    </div>
  )
}

export default QuillToolbar
